import React from "react";
import { Col, Row } from "react-bootstrap";
import { useFormContext } from "react-hook-form";

import { HookFormRadioButton } from "components";
import { ConnectionPrimaryTypes } from "types";

type ConnectionTypeSectionProps = {
	isLoading: boolean;
	sectionName: string;
	connectionName: "Primary" | "Backup";
	defaultValue: string;
};

const ConnectionTypeSection = ({
	isLoading,
	sectionName,
	connectionName,
	defaultValue,
}: ConnectionTypeSectionProps) => {
	const { register, watch } = useFormContext();

	const connectionTypeToNotMatch = watch(
		connectionName === "Primary"
			? `${sectionName}.connectionBackup`
			: `${sectionName}.connectionPrimary`,
	);

	return (
		<div data-autotest="industryTypeSection">
			<p>Connection-{connectionName}</p>
			<Row className="form-group">
				<Col md={2}>
					<HookFormRadioButton
						id={`${sectionName}.connection${connectionName}SIM4G`}
						register={register}
						name={`${sectionName}.connection${connectionName}`}
						value={ConnectionPrimaryTypes.SIM4G.value?.toString()}
						defaultCheckedByValue={defaultValue?.toString()}
						label={ConnectionPrimaryTypes.SIM4G.displayName}
						blurLoading={isLoading}
						disabled={
							connectionTypeToNotMatch ===
							ConnectionPrimaryTypes.SIM4G.value?.toString()
						}
					/>
				</Col>
				<Col md={2}>
					<HookFormRadioButton
						id={`${sectionName}.connection${connectionName}Wireless`}
						register={register}
						name={`${sectionName}.connection${connectionName}`}
						value={ConnectionPrimaryTypes.Wireless.value?.toString()}
						defaultCheckedByValue={defaultValue?.toString()}
						label={ConnectionPrimaryTypes.Wireless.displayName}
						blurLoading={isLoading}
						disabled={
							connectionTypeToNotMatch ===
							ConnectionPrimaryTypes.Wireless.value?.toString()
						}
					/>
				</Col>
				<Col md={2}>
					<HookFormRadioButton
						id={`${sectionName}.connection${connectionName}Ethernet`}
						register={register}
						name={`${sectionName}.connection${connectionName}`}
						value={ConnectionPrimaryTypes.Ethernet.value?.toString()}
						defaultCheckedByValue={defaultValue?.toString()}
						label={ConnectionPrimaryTypes.Ethernet.displayName}
						blurLoading={isLoading}
						disabled={
							connectionTypeToNotMatch ===
							ConnectionPrimaryTypes.Ethernet.value?.toString()
						}
					/>
				</Col>
				<Col md={2}>
					<HookFormRadioButton
						id={`${sectionName}.connection${connectionName}DialUp`}
						register={register}
						name={`${sectionName}.connection${connectionName}`}
						value={ConnectionPrimaryTypes.DialUp.value?.toString()}
						defaultCheckedByValue={defaultValue?.toString()}
						label={ConnectionPrimaryTypes.DialUp.displayName}
						blurLoading={isLoading}
						disabled={
							connectionTypeToNotMatch ===
							ConnectionPrimaryTypes.DialUp.value?.toString()
						}
					/>
				</Col>
			</Row>
		</div>
	);
};

export default ConnectionTypeSection;
